var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import DoNotDiyStyle from './DoNotDiyStyle.js';
/**
 * Warning sign used on the Australian market to inform that an appliance sold must be installed by a licensed electrician.
 */
export default class DoNotDiy extends KompisElement {
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const doNotDiyComplianceData = this.getDoNotDiyInfo();
        const svgUrl = doNotDiyComplianceData && this.getSvgUrl(doNotDiyComplianceData);
        if (!svgUrl || !doNotDiyComplianceData) {
            return html `
				<style>
					:host {
						display: none;
					}
				</style>
			`;
        }
        const { text: altText } = doNotDiyComplianceData;
        return html `<style>
				${DoNotDiyStyle.getStyle()}
			</style>

			${this.getImage(svgUrl, altText)} `;
    }
    getDoNotDiyInfo() {
        const complianceData = this.product.content?.complianceTechnical?.filter((complianceTechnicalItem) => complianceTechnicalItem.headingType === ProductComplianceTechnicalHeadingTypeEnum.doNotDiy);
        return complianceData && complianceData[0];
    }
    getSvgUrl(complianceInfo) {
        let MediaEnum;
        (function (MediaEnum) {
            MediaEnum["svg"] = "00017";
        })(MediaEnum || (MediaEnum = {}));
        const find = (fileTypeCode) => {
            return (complianceInfo.media?.find((mediaType) => mediaType.fileTypeCode === fileTypeCode)?.url ??
                null);
        };
        return find(MediaEnum.svg);
    }
    getImage(svgUrl, altText) {
        return html `<img alt="${altText}" src="${svgUrl}" />`;
    }
}
__decorate([
    property({ type: Object, required: true })
], DoNotDiy.prototype, "product", void 0);
//# sourceMappingURL=DoNotDiy.js.map